import React, { useState } from "react";
import { Form, Spinner } from "react-bootstrap";
import { cdiscManagementService } from "../../../APIServices/CDISC/cdiscManagementService";

const AddNewCMapMetadata = ({ getStudyCDISCCMap, studyId }) => {
  const [codeListName, setCodeListName] = useState("");
  const [source, setSource] = useState("");
  const [target, setTarget] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);

  const addNewStudyCDISCCMap = async () => {
    setButtonLoader(true);
    let userData = {};
    userData.codeListName = codeListName;
    userData.source = source;
    userData.target = target;
    userData.studyId = studyId;
    let data = await cdiscManagementService.addNewStudyCDISCCMap(userData);
    if (data?.statusCode === 200) {
      getStudyCDISCCMap();
      setCodeListName("");
      setSource("");
      setTarget("");
    }
    setButtonLoader(false);
  };

  return (
    <div className="p-2">
      <Form.Group className="mb-1">
        <Form.Label className="mb-1 fw-bold">
          CodeList Name <span className="text-danger">*</span>
        </Form.Label>
        <Form.Control
          required
          type="text"
          value={codeListName}
          onChange={(e) => setCodeListName(e.target.value)}
          placeholder="Enter CodeList Name"
        />
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="mb-1 fw-bold">Source</Form.Label>
        <Form.Control
          type="text"
          value={source}
          onChange={(e) => setSource(e.target.value)}
          placeholder="Enter source "
        />
      </Form.Group>
      <Form.Group className="mb-1">
        <Form.Label className="mb-1 fw-bold">Target</Form.Label>
        <Form.Control
          type="text"
          value={target}
          onChange={(e) => setTarget(e.target.value)}
          placeholder="Enter Target"
        />
      </Form.Group>
      <Form.Group className="text-end">
        <button
          disabled={buttonLoader || !codeListName}
          onClick={addNewStudyCDISCCMap}
          className="updateProfile"
        >
          {buttonLoader ? (
            <div className="hstack gap-2">
              <Spinner size="sm" /> Adding...
            </div>
          ) : (
            "Add CMap"
          )}
        </button>
      </Form.Group>
    </div>
  );
};

export default AddNewCMapMetadata;
